module.exports = __webpack_public_path__ + "static/img/sjyy-details.29b1eb9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/sjyy-details.png
// module id = GIRO
// module chunks = 0